import { safeLocalStorage } from 'helpers/localStorage'
import { SIDEBAR_SORTS, SidebarSort } from 'components/sidebar/components/folders/tree'

// Per-viewer sidebar display state. safeLocalStorage swallows storage errors (private windows,
// blocked site data), so the sidebar still works there — it just forgets between visits.

/** Expanded folders are remembered per hub. */
const expandedKey = (hubId: string): string => `morta.sidebar.expanded.${hubId}`

export const loadExpanded = (hubId: string): Set<string> => {
  try {
    const parsed: unknown = JSON.parse(safeLocalStorage.getItem(expandedKey(hubId)) ?? '[]')
    return new Set(Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [])
  } catch {
    return new Set()
  }
}

export const saveExpanded = (hubId: string, expanded: Set<string>): void =>
  safeLocalStorage.setItem(expandedKey(hubId), JSON.stringify([...expanded]))

/** The viewer's sort is also persisted per hub. No saved sort, or one this build doesn't know, is Manual. */
const sortKey = (hubId: string): string => `morta.sidebar.sort.${hubId}`

export const loadSort = (hubId: string): SidebarSort => {
  const saved = safeLocalStorage.getItem(sortKey(hubId))
  return SIDEBAR_SORTS.find((sort) => sort === saved) ?? 'manual'
}

export const saveSort = (hubId: string, sort: SidebarSort): void => safeLocalStorage.setItem(sortKey(hubId), sort)

/** Whether the viewer lists folders first, per hub. Off unless they turned it on. */
const foldersFirstKey = (hubId: string): string => `morta.sidebar.foldersFirst.${hubId}`

export const loadFoldersFirst = (hubId: string): boolean => safeLocalStorage.getItem(foldersFirstKey(hubId)) === 'true'

export const saveFoldersFirst = (hubId: string, foldersFirst: boolean): void =>
  safeLocalStorage.setItem(foldersFirstKey(hubId), String(foldersFirst))
